module.exports = "/components/components/purchasePremiumButtonComponent-16cb47.html";